// extracted by mini-css-extract-plugin
export var body = "_mr-8";
export var button = "_mr-0";
export var closeButton = "_mr-5";
export var content = "_mr-3";
export var empty = "_mr-f";
export var grid = "_mr-c";
export var header = "_mr-4";
export var icon = "_mr-1";
export var option = "_mr-d";
export var optionSelected = "_mr-e";
export var overlay = "_mr-2";
export var searchIcon = "_mr-a";
export var searchInput = "_mr-b";
export var searchWrapper = "_mr-9";
export var title = "_mr-6";
export var visuallyHidden = "_mr-7";